export enum WebsocketTypes {
  WEBSOCKET_MESSAGE = 'websocket_message',
}

export interface IWebsocketState {
  message: string
  key: string
}

interface IWebsocketMessageAction extends IWebsocketState {
  type: typeof WebsocketTypes.WEBSOCKET_MESSAGE
}

export type WebsocketActionTypes = IWebsocketMessageAction
export type WebsocketState = IWebsocketState

export const initialState: WebsocketState = {
  message: null,
  key: null
}
export const websocketReducer = (initialState: WebsocketState, action: WebsocketActionTypes): WebsocketState => {
  switch (action.type) {
    case WebsocketTypes.WEBSOCKET_MESSAGE:
      return {
        ...initialState, message: action.message, key: action.key
      }
    default:
      return initialState
  }
}
